/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Schema for updating a lesson.
 * @export
 * @interface LessonUpdate
 */
export interface LessonUpdate {
    /**
     * 
     * @type {string}
     * @memberof LessonUpdate
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LessonUpdate
     */
    topic?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LessonUpdate
     */
    description?: string | null;
    /**
     * 
     * @type {number}
     * @memberof LessonUpdate
     */
    order?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof LessonUpdate
     */
    deleted?: boolean | null;
}

/**
 * Check if a given object implements the LessonUpdate interface.
 */
export function instanceOfLessonUpdate(value: object): value is LessonUpdate {
    return true;
}

export function LessonUpdateFromJSON(json: any): LessonUpdate {
    return LessonUpdateFromJSONTyped(json, false);
}

export function LessonUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): LessonUpdate {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'topic': json['topic'] == null ? undefined : json['topic'],
        'description': json['description'] == null ? undefined : json['description'],
        'order': json['order'] == null ? undefined : json['order'],
        'deleted': json['deleted'] == null ? undefined : json['deleted'],
    };
}

export function LessonUpdateToJSON(json: any): LessonUpdate {
    return LessonUpdateToJSONTyped(json, false);
}

export function LessonUpdateToJSONTyped(value?: LessonUpdate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'topic': value['topic'],
        'description': value['description'],
        'order': value['order'],
        'deleted': value['deleted'],
    };
}

